export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            投稿、建议或合作意向，欢迎通过以下方式与我们取得联系
          </p>
        </div>

        <div className="max-w-[720px] mx-auto">
          <div className="rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="flex flex-col items-center text-center gap-2 p-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <p className="font-medium text-sm text-foreground-900">投稿邮箱</p>
                <a
                  href="#contact"
                  onClick={(e) => e.preventDefault()}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  submit@krmh.example.com
                </a>
              </div>
              <div className="flex flex-col items-center text-center gap-2 p-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className="ri-chat-smile-2-line text-xl"></i>
                </div>
                <p className="font-medium text-sm text-foreground-900">官方社群</p>
                <a
                  href="#contact"
                  onClick={(e) => e.preventDefault()}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  加入读者交流群
                </a>
              </div>
              <div className="flex flex-col items-center text-center gap-2 p-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600">
                  <i className="ri-team-line text-xl"></i>
                </div>
                <p className="font-medium text-sm text-foreground-900">商务合作</p>
                <a
                  href="#contact"
                  onClick={(e) => e.preventDefault()}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  bd@krmh.example.com
                </a>
              </div>
            </div>

            <div className="border-t border-background-200/70 pt-6 text-center">
              <p className="text-sm text-foreground-600 mb-4">
                无论你是韩漫作者、翻译组还是热心读者，我们都期待你的来信
              </p>
              <p className="text-xs text-foreground-500">
                回复时间：工作日 9:00 - 18:00，通常在 24 小时内回复
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}